import actionTypes from 'Utils/actionTypes'

export const GET_LEADS_CHART = {
  ...actionTypes('GET_LEADS_CHART'),
  empty: 'GET_LEADS_CHART_EMPTY',
}
